import style from './burger-menu-nav-item.module.scss';
import Image from 'next/legacy/image';
import { HeaderNavigation } from '../../header.state';
import { Themes } from '@layouts/main-layout/themes.enum';
import ShouldRender from '@components/shared/boundaries/should-render';
import AgilieLink from '@components/shared/links/agilie-link';
import { useTranslations } from 'next-intl';
import { forwardRef } from 'react';

interface IBurgerMenuNavItemProps {
  item: HeaderNavigation;
  onMenuClicked: () => void;
  theme?: Themes;
  active: boolean;
  onExpand: () => void;
}

const ExpandableNavigationItem = ({ active, item, theme }: any) => {
  const iconClasses: string = active ? style.active : '';
  const iconSrc: string = '/assets/icons/icn-arrow.svg';
  const iconAlt: string = `Expand ${item.name}`;
  const t = useTranslations();

  return (
    <>
      <span>{t(item.name)}</span>
      <div className={`${style.link__icon} ${iconClasses} ${style[theme]}`}>
        <Image src={iconSrc} alt={iconAlt} width={20} height={20} />
      </div>
    </>
  );
};

export default forwardRef<HTMLDivElement, IBurgerMenuNavItemProps>(function BurgerMenuNavItem({
  item,
  onMenuClicked,
  theme = Themes.Default,
  active,
  onExpand,
}: IBurgerMenuNavItemProps, ref) {
  theme = theme || Themes.Default;
  const isExpandable: boolean = !!item.burgerPreview;
  const t = useTranslations();

  return (
    <div ref={ref} className={`${style.wrapper} ${style[theme]} ${active ? style.active : ''}`}>
      <div onClick={() => isExpandable && onExpand()} className={style.link}>
        <ShouldRender
          if={isExpandable}
          else={
            <AgilieLink
              href={item.link}
              label={t(item.name)}
              onClick={onMenuClicked}
              classNames={style.link__item}
            />
          }
        >
          <ExpandableNavigationItem active={active} item={item} theme={theme} />
        </ShouldRender>
      </div>
      <ShouldRender if={active}>{item.burgerPreview?.(theme, onMenuClicked) ?? <></>}</ShouldRender>
    </div>
  );
});
